/**
 * MobileMiControl — envuelve la página existente `MiControlGestiones`
 * dentro del shell móvil (top-bar + bottom-nav). La página interna ya es
 * responsive (max-w-5xl + px-4 md:px-6) así que se reutiliza tal cual.
 *
 * Esto evita duplicar la lógica de control horario / km / vacaciones que
 * ya está validada en desktop, y mantiene el comportamiento idéntico entre
 * dispositivos.
 */
import MobileShell from "@/mobile/MobileShell";
import MiControlGestiones from "@/pages/MiControlGestiones";

export default function MobileMiControl() {
  return (
    <MobileShell title="Mi control y gestiones">
      <MiControlGestiones />
    </MobileShell>
  );
}
